import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import type { RoleType } from '../types';

interface RoleTypeBadgeProps {
  type: RoleType;
  className?: string;
}

const typeColors: Record<RoleType, string> = {
  MANAGER: 'bg-blue-500',
  PARTNER: 'bg-purple-500',
  STAFF: 'bg-gray-500',
  LEAD: 'bg-amber-500',
  MD: 'bg-emerald-500',
};

export function RoleTypeBadge({ type, className }: RoleTypeBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      className={`rounded-full text-white ${typeColors[type] || 'bg-gray-500'} ${className || ''}`}
    >
      {t(type.toLowerCase())}
    </Badge>
  );
}
